<template>
  <v-card class="cts-tab-item-content" flat>
    <v-card-title class="cts-tab-title mx-3 mb-3 py-0 px-2 hidden-xs-only">
      <h4>
        <v-icon class="mr-1" left size="19">{{const_icons.CHANGE_PASS}}</v-icon>
        {{$vuetify.lang.t('$vuetify.passwordchange')}}
      </h4>
    </v-card-title>
    <v-card-text class="cts-tab-content pa-0 px-sm-4">
      <v-row class="ma-0 pa-0" dense>
        <v-col class="ma-0 pa-0" cols="12" lg="12" md="12" sm="12" xl="12">
          <v-row>
            <v-col class="cts-field-medium-block pa-0 px-sm-3" cols="12" md="6" xl="4">
              <v-form
                ref="form"
                v-model="valid"
                class="cts-form-login mt-4"
                lazy-validation
              >
                <v-col class="cts-field-medium-block" cols="12" md="12">
                  <span class="cts-form-labeled-input">{{$vuetify.lang.t('$vuetify.oldpassword')}}</span>
                  <v-text-field
                    v-model="input.old_password"
                    :aria-label="$vuetify.lang.t('$vuetify.oldpassword')"
                    :placeholder="$vuetify.lang.t('$vuetify.oldpassword')"
                    :value="input.old_password"
                    autocomplete="off"
                    name="oldPassword"
                    outlined
                    required
                    type="password"
                  />
                </v-col>
                <v-col class="cts-field-medium-block" cols="12" md="12">
                  <span class="cts-form-labeled-input">{{$vuetify.lang.t('$vuetify.newpassword')}}</span>
                  <v-text-field v-model="input.password"
                                :aria-label="$vuetify.lang.t('$vuetify.newpassword')"
                                :maxlength="passwordMaxLength"
                                :placeholder="$vuetify.lang.t('$vuetify.newpassword')"
                                :rules="passwordRules"
                                :value="input.password"
                                name="password"
                                outlined
                                type="password"
                  />
                </v-col>
                <v-col class="cts-field-medium-block" cols="12" md="12">
                  <span class="cts-form-labeled-input">{{$vuetify.lang.t('$vuetify.repeatpassword')}}</span>
                  <v-text-field v-model="input.repeat_password"
                                :aria-label="$vuetify.lang.t('$vuetify.repeatpassword')"
                                :placeholder="$vuetify.lang.t('$vuetify.repeatpassword')"
                                :rules="confirmPasswordRules"
                                autocomplete="on"
                                name="passwordRepeat"
                                outlined
                                type="password"
                  />
                </v-col>
                <v-expand-transition>
                  <v-row v-if="errorMessage != null" class="ma-0 cts-login-error-message" dense>
                    <span class="caption">{{errorMessage}}</span>
                  </v-row>
                </v-expand-transition>
              </v-form>
            </v-col>
            <v-col cols="12" lg="6" md="6" sm="12" xl="8">
              <transition appear name="hint">
                <v-row class="ma-0 pa-0">
                  <v-col class="pb-2" cols="12" lg="12" md="12" sm="12" xl="12">
                    <span class="cts-form-labeled-input">{{$vuetify.lang.t('$vuetify.passwordrequirements')}} </span>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="12" md="12" sm="12" xl="4">
                    <div class="cts-passwordrequirements-paragraph mt-0 pa-0">
                      <v-row class="ma-0 pa-0" dense>
                        <v-col class="ma-0 pa-0" cols="1">
                          <v-icon :class="lengthRequirement.valid ? 'cts-field-ok' : 'cts-field-error'" size="20">
                            check_circle
                          </v-icon>
                        </v-col>
                        <v-col class="ma-0 pa-0" cols="11">
                          <span class="ml-2">{{lengthRequirement.message}}</span>
                        </v-col>
                      </v-row>

                      <v-row class="ma-0 pa-0" dense>
                        <v-col class="pa-0 mt-3" cols="12">
                          <span
                            class="cts-form-labeled-input">{{$vuetify.lang.t('$vuetify.passwordminrequirements')}} </span>
                        </v-col>
                      </v-row>

                      <v-row v-for="optionalRule in optionalRequirements" :key="optionalRule.key" class="ma-0 pa-0"
                             dense>
                        <v-col class="ma-0 pa-0" cols="1">
                          <v-icon :class="optionalRule.valid ? 'cts-field-ok' : 'cts-field-error'" size="20">
                            check_circle
                          </v-icon>
                        </v-col>
                        <v-col class="ma-0 pa-0" cols="11">
                          <span class="ml-2">{{optionalRule.message}}<template v-if="optionalRule.key === 'special'"> ({{passwordSpecialCharsDisplay}})</template></span>
                        </v-col>
                      </v-row>
                      <v-row v-if="!allValidationsAreOK" class="ma-0 pa-0">
                        <v-col class="ma-0 pa-0">
                          <div v-if='notSamePasswords'>
                            <span
                              class="cts-form-labeled-input mt-4 cts-color-error font-weight-bold">{{$vuetify.lang.t('$vuetify.notequalpasswords')}} </span>
                          </div>
                          <div v-if='samePasswordThanOldPassword'>
                            <span
                              class="cts-form-labeled-input mt-4 cts-color-error font-weight-bold">{{$vuetify.lang.t('$vuetify.samepasswordthanolder')}} </span>
                          </div>
                          <div v-if="passwordsFilled && input.old_password === ''">
                            <span
                              class="cts-form-labeled-input mt-4 cts-color-error font-weight-bold"> {{$vuetify.lang.t('$vuetify.emptyOldPassword')}} </span>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </transition>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import const_global from "@/constants/global";
import {
  NAMESPACE as AUTHENTICATION_NAMESPACE,
  GETTERS as AUTHENTICATION_GETTERS,
  STATE as AUTHENTICATION_STATE
} from "@/constants/vuex/authentication"
import const_icons from "@/constants/icons";
import passwordValidationMixin from "@/mixins/passwordValidation-mixin"

export default {
  name: "sectionUserPassChange",
  mixins: [passwordValidationMixin],
  data() {
    return {
      const_icons,
      valid: false,
      validHash: false,
      errorMessage: null,
      loggingIn: false,
      loader: false,
      id: null,
      token: null,
      visible: false,
      input: {
        old_password: "",
        password: "",
        repeat_password: ""
      },
      username: null,
      confirmPasswordRules: [
        v => !!v || this.$vuetify.lang.t('$vuetify.passwordCompares')
      ],
      const_global,
      userInfo: {}
    }
  },
  computed: {
    passwordsFilled() {
      return (this.input.password !== '' && this.input.repeat_password !== '')
    },

    notSamePasswords() {
      return this.passwordsFilled ? (this.input.password !== this.input.repeat_password) : false
    },

    samePasswordThanOldPassword() {
      if (this.input.password !== '' && this.input.old_password !== '') {
        return (this.input.password == this.input.old_password)
      }

      return false
    },

    allValidationsAreOK() {
      let validation
      if (this.samePasswordThanOldPassword || !this.passwordMeetsRequirements || this.input.repeat_password === '' ||
        this.notSamePasswords || this.input.old_password === '') {
        validation = false
        this.$emit("activateSaveButton", false)
      } else {
        validation = true
        this.$emit("activateSaveButton", {
          section: "userPassChanged",
          data: this.userData
        })
      }

      return validation
    },

    userData() {
      return {
        username: this.$store.state[AUTHENTICATION_NAMESPACE][AUTHENTICATION_STATE.S_USERNAME],
        new_password: this.input.repeat_password,
        old_password: this.input.old_password,
        from_remember: false
      }
    }
  },
  created() {
    this.username = this.$store.getters[`${AUTHENTICATION_NAMESPACE}/${AUTHENTICATION_GETTERS.G_LOGIN_DATA}`].username
  },
  methods: {
    setErrorMessage(error_message) {
      this.errorMessage = error_message
    }
  }
}
</script>
